// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.centerbox {
  width: 100%;
  background-color: #00000087;
  position: relative;
  overflow: hidden;
  position: relative;
  overflow: hidden;
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  /* backdrop-filter: blur(2px); */
}

.loader {
  width: 48px;
  height: 48px;
  margin: auto;
  position: relative;
}

.loader:before {
  content: '';
  width: 48px;
  height: 5px;
  background: #554719;
  position: absolute;
  top: 60px;
  left: 0;
  border-radius: 50%;
  animation: shadow324 0.5s linear infinite;
}

.loader:after {
  content: '';
  width: 100%;
  height: 100%;
  background: #603fd7;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 4px;
  animation: jump7456 0.5s linear infinite;
}

@keyframes jump7456 {
  15% {
    border-bottom-right-radius: 3px;
  }

  25% {
    transform: translateY(9px) rotate(22.5deg);
  }

  50% {
    transform: translateY(18px) scale(1, .9) rotate(45deg);
    border-bottom-right-radius: 40px;
  }

  75% {
    transform: translateY(9px) rotate(67.5deg);
  }

  100% {
    transform: translateY(0) rotate(90deg);
  }
}

@keyframes shadow324 {

  0%,
  100% {
    transform: scale(1, 1);
  }

  50% {
    transform: scale(1.2, 1);
  }
}`, "",{"version":3,"sources":["webpack://./src/Services/Loading/Loading.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,MAAM;EACN,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,sDAAsD;IACtD,gCAAgC;EAClC;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,sCAAsC;EACxC;AACF;;AAEA;;EAEE;;IAEE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".centerbox {\r\n  width: 100%;\r\n  background-color: #00000087;\r\n  position: relative;\r\n  overflow: hidden;\r\n  position: relative;\r\n  overflow: hidden;\r\n  position: fixed;\r\n  z-index: 99999;\r\n  top: 0;\r\n  left: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100vh;\r\n  /* backdrop-filter: blur(2px); */\r\n}\r\n\r\n.loader {\r\n  width: 48px;\r\n  height: 48px;\r\n  margin: auto;\r\n  position: relative;\r\n}\r\n\r\n.loader:before {\r\n  content: '';\r\n  width: 48px;\r\n  height: 5px;\r\n  background: #554719;\r\n  position: absolute;\r\n  top: 60px;\r\n  left: 0;\r\n  border-radius: 50%;\r\n  animation: shadow324 0.5s linear infinite;\r\n}\r\n\r\n.loader:after {\r\n  content: '';\r\n  width: 100%;\r\n  height: 100%;\r\n  background: #603fd7;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  border-radius: 4px;\r\n  animation: jump7456 0.5s linear infinite;\r\n}\r\n\r\n@keyframes jump7456 {\r\n  15% {\r\n    border-bottom-right-radius: 3px;\r\n  }\r\n\r\n  25% {\r\n    transform: translateY(9px) rotate(22.5deg);\r\n  }\r\n\r\n  50% {\r\n    transform: translateY(18px) scale(1, .9) rotate(45deg);\r\n    border-bottom-right-radius: 40px;\r\n  }\r\n\r\n  75% {\r\n    transform: translateY(9px) rotate(67.5deg);\r\n  }\r\n\r\n  100% {\r\n    transform: translateY(0) rotate(90deg);\r\n  }\r\n}\r\n\r\n@keyframes shadow324 {\r\n\r\n  0%,\r\n  100% {\r\n    transform: scale(1, 1);\r\n  }\r\n\r\n  50% {\r\n    transform: scale(1.2, 1);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
